import type { CommandServices } from '@wix/cli-command-contract';
import { createEnv } from '@wix/cli-env';
import { openBrowser } from '@wix/user-browser';
import { log } from '../log.js';
import { buildDomainPurchaseUrl } from './domain-purchase-url.js';

interface RunBuyDomainParams {
  domain: string;
  json?: boolean;
  siteId?: string;
}

export async function runBuyDomain(
  services: CommandServices,
  { domain, json, siteId }: RunBuyDomainParams
): Promise<void> {
  const purchaseUrl = buildDomainPurchaseUrl(domain, siteId);

  if (json) {
    log(JSON.stringify({ url: purchaseUrl }));
    return;
  }

  const shouldOpenBrowser = services.loginMode !== 'agent' && !createEnv().isCI;

  if (!shouldOpenBrowser) {
    log(purchaseUrl);
    return;
  }

  log(
    `Opening your browser to buy ${domain}. Complete the purchase and payment on Wix.`
  );
  log(`If your browser doesn't open, go to: ${purchaseUrl}`);

  await openBrowser(purchaseUrl).catch(() => {});
}
